import type { ParsedPublicMessage } from '@module/types/centrifuge/messageTypes';
import { type CaptionMessage, isCaptionMessage } from '@module/types/centrifuge/public-message/captionMessageTypes';
import type { MessageHandler, MessageHandlerAction, MessageHandlerContext } from '../types';

export class CaptionHandler implements MessageHandler {
  constructor(private customAction?: MessageHandlerAction<CaptionMessage>) {}

  canHandle(payload: ParsedPublicMessage): boolean {
    return isCaptionMessage(payload);
  }

  handle(payload: CaptionMessage, context: MessageHandlerContext): void {
    if (this.customAction === null || this.customAction === undefined) return;

    if (typeof this.customAction === 'function') {
      this.customAction(payload, context);
      return;
    }

    // 기본 동작
    context.addCaption?.(payload);
  }
}
